function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.80566 19.6914H16.0005H27.1954C27.1954 24.1075 24.6894 27.6878 21.598 27.6878C18.5066 27.6878 16.0005 24.1075 16.0005 19.6914C16.0005 24.1075 13.4945 27.6878 10.4031 27.6878C7.31172 27.6878 4.80566 24.1075 4.80566 19.6914Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("mask", {
  id: "path-2-inside-1",
  fill: "white"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9967 0.5H8.00403L4.8055 13.2941H27.1952L23.9967 0.5ZM31.9932 13.2942H0.0078125V16.4928H31.9932V13.2942Z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.00403 0.5V-1H6.83287L6.54882 0.136197L8.00403 0.5ZM23.9967 0.5L25.4519 0.136197L25.1679 -1H23.9967V0.5ZM4.8055 13.2941L3.35029 12.9303L2.88433 14.7941H4.8055V13.2941ZM27.1952 13.2941V14.7941H29.1164L28.6505 12.9303L27.1952 13.2941ZM0.0078125 13.2942V11.7942H-1.49219V13.2942H0.0078125ZM31.9932 13.2942H33.4932V11.7942H31.9932V13.2942ZM0.0078125 16.4928H-1.49219V17.9928H0.0078125V16.4928ZM31.9932 16.4928V17.9928H33.4932V16.4928H31.9932ZM8.00403 2H23.9967V-1H8.00403V2ZM6.26071 13.6579L9.45925 0.863803L6.54882 0.136197L3.35029 12.9303L6.26071 13.6579ZM27.1952 11.7941H4.8055V14.7941H27.1952V11.7941ZM22.5415 0.863803L25.74 13.6579L28.6505 12.9303L25.4519 0.136197L22.5415 0.863803ZM0.0078125 14.7942H31.9932V11.7942H0.0078125V14.7942ZM1.50781 16.4928V13.2942H-1.49219V16.4928H1.50781ZM31.9932 14.9928H0.0078125V17.9928H31.9932V14.9928ZM30.4932 13.2942V16.4928H33.4932V13.2942H30.4932Z",
  fill: "white",
  mask: "url(#path-2-inside-1)"
});

var SvgPrivateMatch = function SvgPrivateMatch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPrivateMatch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/privateMatch.91ead518.svg";
export { ForwardRef as ReactComponent };